import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import Token from "utils/token";

Vue.use(VueRouter);

// meta: {
//   submenu: "", //layout -> name 一级目录名称
//   menuItem: "", //layout -> children -> name 二级目录名称
// },
const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/index"),
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/search"),
  },
  {
    path: "/cart",
    name: "cart",
    meta: {
      title: '购物车',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/cart"),
  },
  {
    path: "/price",
    name: "price",
    meta: {
      title: '域名注册',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/price"),
  },
  {
    path: "/whoisSearch",
    name: "whoisSearch",
    meta: {
      title: 'Whois查询',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/whoisSearch"),
  },
  {
    path: "/whois",
    name: "whois",
    meta: {
      title: 'Whois查询',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/whois"),
  },
  {
    path: "/emailc",
    name: "emailc",
    meta: {
      title: '邮箱认证',
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/home/emailc"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: '登录',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/login"),
  },
  {
    path: "/sige",
    name: "sige",
    meta: {
      title: '免费注册',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/sige"),
  },
  {
    path: "/forgot",
    name: "forgot",
    meta: {
      title: '忘记密码',
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/forgot"),
  },
  {
    path: "/user",
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/user/components/layout"),
    children: [
      {
        path: "",
        name: "user",
        meta: {
          title: '控制台',
        },
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/user/index"),
      },
      {
        path: "domain",
        name: "domain",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: '我的域名',
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myDomain/index"
          ),
      },
      {
        path: "template",
        meta: {
          submenu: "domain",
          menuItem: "domain-myTemplate",
          title: '我的模板',
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/container"
          ),
        children: [
          {
            path: "",
            name: "template",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "我的模板",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/index"
              ),
          },
          {
            path: "add",
            name: "templateAdd",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "添加模板",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/add"
              ),
          },
          {
            path: "transfer",
            name: "templateTransfer",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/transfer"
              ),
          },
          {
            path: "default",
            name: "templateDefault",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "设置默认模板",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/default"
              ),
          },
          {
            path: "transferlist",
            name: "templateTransferlist",
            meta: {
              submenu: "domain",
              menuItem: "domain-myTemplate",
              title: "模板过户记录",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/myTemplate/transferlist"
              ),
          },
        ],
      },
      {
        path: "push",
        meta: {
          submenu: "domain",
          menuItem: "domain-push",
          title: "域名PUSH",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/push/container"
          ),
        children: [
          {
            path: "",
            name: "pushIndex",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "域名PUSH",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/index"
              ),
          },
          {
            path: "receive",
            name: "pushReceive",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "收到的请求",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/receive"
              ),
          },
          {
            path: "sent",
            name: "pushSent",
            meta: {
              submenu: "domain",
              menuItem: "domain-push",
              title: "发出的请求",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/push/sent"
              ),
          },
        ],
      },
      {
        path: "transferin",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferin",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/transferin/container"
          ),
        children: [
          {
            path: "",
            name: "transferin",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferin/index"
              ),
          },
          {
            path: "record",
            name: "transferinRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferin",
              title: "域名转入记录",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferin/record"
              ),
          },
        ],
      },
      {
        path: "transferout",
        meta: {
          submenu: "domain",
          menuItem: "domain-transferout",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/transferout/container"
          ),
        children: [
          {
            path: "",
            name: "transferout",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferout/index"
              ),
          },
          {
            path: "record",
            name: "transferoutRecord",
            meta: {
              submenu: "domain",
              menuItem: "domain-transferout",
              title: "域名转出记录",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/transferout/record"
              ),
          },
        ],
      },
      {
        path: "order",
        meta: {
          submenu: "domain",
          menuItem: "domain-order",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/order/container"
          ),
        children: [
          {
            path: "",
            name: "order",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单",

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/order/index"
              ),
          },
          {
            path: "detail",
            name: "orderDetail",
            meta: {
              submenu: "domain",
              menuItem: "domain-order",
              title: "域名订单详情",
              toBack: true,

            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/domain/order/detail"
              ),
          },
        ],
      },
      {
        path: "account",
        meta: {
          submenu: "account",
          menuItem: "account",

        },
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/user/info/container"),
        children: [
          {
            path: "",
            name: "account",
            meta: {
              submenu: "account",
              menuItem: "account-account",
              title: "个人资料",
            },
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/user/info/index"),
          },
          {
            path: "security",
            name: "accountSecurity",
            meta: {
              submenu: "account",
              menuItem: "account-security",
              title: "安全中心",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/security"
              ),
          },
          {
            path: "certified",
            name: "accountCertified",
            meta: {
              submenu: "account",
              menuItem: "account-certified",
              title: "我的认证",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/certified"
              ),
          },
          {
            path: "mail",
            name: "accountMail",
            meta: {
              submenu: "account",
              menuItem: "account-mail",
              title: "站内信",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/mail"
              ),
          },
          {
            path: "journal",
            name: "accountJournal",
            meta: {
              submenu: "account",
              menuItem: "account-journal",
              title: "登陆日志",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/journal"
              ),
          },
          {
            path: "myPersonal",
            name: "accountMyPersonal",
            meta: {
              submenu: "account",
              menuItem: "account-certified",
              toBack: true,
              title: "个人认证",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myPersonal"
              ),
          },
          {
            path: "myEnterprise",
            name: "accountMyEnterprise",
            meta: {
              submenu: "account",
              menuItem: "account-certified",
              toBack: true,
              title: "企业认证",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myEnterprise"
              ),
          },
          {
            path: "myEmail",
            name: "accountMyEmail",
            meta: {
              submenu: "account",
              menuItem: "account-certified",
              toBack: true,
              title: "邮箱认证",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/info/myEmail"
              ),
          },
        ],
      },
      {
        path: "finance/account",
        name: "financeAccount",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "账户信息",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/index"
          ),
      },
      {
        path: "finance/account/recharge",
        name: "financeAccountRecharge",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "在线充值",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/recharge"
          ),
      },
      {
        path: "finance/account/cashout",
        name: "financeAccountCashout",
        meta: {
          submenu: "finance",
          menuItem: "finance-account",
          title: "资金提现",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/account/cashout"
          ),
      },
      {
        path: "finance/capitaldetails/index",
        name: "financeCapitaldetails",
        meta: {
          submenu: "finance",
          menuItem: "finance-capitaldetails",
          title: "资金明细",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/capitaldetails/index"
          ),
      },
      {
        path: "invoice",
        meta: {
          submenu: "finance",
          menuItem: "finance-invoice",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/finance/invoice/container"
          ),
        children: [
          {
            path: "",
            name: "invoice",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/index"
              ),
          },
          {
            path: "apply",
            name: "financeapply",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/apply"
              ),
          },
          {
            path: "detail",
            name: "invoicedetail",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/detail"
              ),
          },
          {
            path: "info",
            name: "invoiceinfo",
            meta: {
              submenu: "finance",
              menuItem: "finance-invoice",
            },
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/finance/invoice/info"
              ),
          },
        ],
      },
      {
        path: "domain/analysis",
        name: "domainAnalysis",
        meta: {
          submenu: "domain",
          menuItem: "domain-myDomain",
          title: "解析设置",
        },
        component: () =>
          import(
            /* webpackChunkName: "user" */ "../views/user/domain/myDomain/analysis"
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
// 路由跳转前钩子
router.beforeEach((to, from, next) => {
  if (!(store.state.token.token && store.state.token.token != '')) {
    const rToken = Token.getAll()
    if (rToken && rToken != '') {
      store.commit('MUT_TOKEN_INFO', JSON.parse(rToken));
      store.dispatch('ACT_USER_INFO')
    }
  }
  // 如果已经登录了，不能让它打开登录、注册、忘记密码页面
  const isLogin = store.state.token != "";
  if (
    isLogin &&
    (to.name === "login" || to.name === "sige" || to.name === "forgot")
  ) {
    if (
      from.name === "login" ||
      from.name === "sige" ||
      from.name === "forgot"
    ) {
      next("/index");
    } else {
      next(from);
    }
    return false;
  }
  // 如果是从其他页面去登录页面,记录原本的路由
  if (to.name === "login") {
    const { name, path, query, params } = from;

    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
  }
  // 如果未登录进入个人中心
  if (to.fullPath.search("/user") !== -1 && !isLogin) {
    const { name, path, query, params } = from;
    let data = {};
    data["name"] = name || "index";
    data["path"] = path || "/";
    data["query"] = query || {};
    data["params"] = params || {};
    router.app.$store && router.app.$store.commit("MUT_ROUTE", data);
    next("/index");
    return false;
  }
  // if(to.name)
  next();
  if (to.meta.title) {
    document.title = `${to.meta.title} ` + ' _智绘网络';
  }
});

export default router;
